// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconDeviceLaptop = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M61.1716 47.1716L54 40V14C54 11.5318 52.4681 10 50 10H14C11.5319 10 10 11.5318 10 14V40L2.82843 47.1716C2.23578 47.7642 2 48.3334 2 49.1716C2 50.9168 3.08319 52 4.82843 52H59.1716C60.9168 52 62 50.9168 62 49.1716C62 48.3334 61.7642 47.7642 61.1716 47.1716ZM48 30.0001C48 31.2341 47.2341 32.0001 46 32.0001H44C42.7659 32.0001 42 31.2341 42 30.0001V28.0001C42 26.766 42.7659 26.0001 44 26.0001H46C47.2341 26.0001 48 26.766 48 28.0001V30.0001ZM48 20.0001C48 21.2341 47.2341 22.0001 46 22.0001H44C42.7659 22.0001 42 21.2341 42 20.0001V18.0001C42 16.766 42.7659 16.0001 44 16.0001H46C47.2341 16.0001 48 16.766 48 18.0001V20.0001Z" />
    </svg>
  );
};
